import { useEffect, useState } from "react";
import { BsXLg } from "react-icons/bs";
import { Input } from "reactstrap";
import { User } from "../../../interfaces/interfaces";
import { UsersRestS } from "../../../rest/users-rest-service";
import styles from "./EditGroupMembers.module.scss";

export default function EditGroupMembers({
  users,
  onClose,
  groupId,
  setGroupUserList,
}) {
  const [userList, setUserList] = useState([]);
  const [selectedUsers, setSelectedUser] = useState([]);
  const [groupMembers, setGroupMembers] = useState([]);
  const [removedUser, setRemovedUser] = useState([]);

  useEffect(() => {
    UsersRestS.getUsersByCompany()
      .then((res) => {
        setUserList(res);
      })
      .catch((e) => console.error(e));
    // let ids = users?.map((u) => u.user_id)
    // setSelectedUser(ids);
    // setGroupMembers(ids);
    if (users !== undefined && users.length > 0) {
      //
      let ids = users?.map((u) => u.user_id);
      //
      setSelectedUser(ids);
      setGroupMembers(ids);
      // setSelectedUser(membersFieldState);
    } else {
      setSelectedUser([]);
      setGroupMembers([]);
    }
  }, []);

  const changeSelection = (val) => {
    if (selectedUsers.includes(val)) {
      if (groupMembers.includes(val)) {
        setRemovedUser([...removedUser, val]);
      }
      let ids = selectedUsers.filter((e) => e != val);
      setSelectedUser([...ids]);
    } else {
      setSelectedUser([...selectedUsers, val]);
    }
  };

  const doneButton = () => {
    let newUser = selectedUsers.filter((obj) => {
      return groupMembers.indexOf(obj) == -1;
    });
    //
    UsersRestS.addMemberInGroup(newUser, removedUser, groupId)
      .then((res) => {
        //
        onClose();
        setGroupUserList(res);
      })
      .catch((e) => console.error(e));
  };

  const checkUserIdExists = (userId) => {
    //
    //
    return <></>;
  };
  return (
    <div className={styles.addUserPannel}>
      <div className={styles.addMembersDiv}>
        <div className={styles.header}>
          <div className={styles.heading}>Add members to group</div>
          <div className={`${styles.icon}`} onClick={onClose}>
            <BsXLg />
          </div>
        </div>
        <div className={styles.addMembersBlock}>
          {userList &&
            userList.map((user: User, index) => {
              return (
                <div
                  className={styles.membersList}
                  key={index}
                  onClick={() => changeSelection(user.id)}
                >
                  {/* <Input className={styles.checkBox} type="checkbox" checked={selectedUsers.includes(user.id)} onClick={() => changeSelection(user.id)} /> */}

                  <div className={styles.customSelect}>
                    {selectedUsers.includes(user.id) ? (
                      <div className={styles.innerSelect}></div>
                    ) : null}
                  </div>
                  <div className={styles.membersInfo}>
                    <div
                      style={{
                        backgroundColor: user.color
                          ? `#${user.color}`
                          : "#596de7",
                        cursor: "pointer",
                      }}
                      className={`${styles.profileImage}`}
                    >
                      {user.name.charAt(0).toUpperCase()}
                    </div>
                    <div className={styles.membersNameDesignation}>
                      <div className={styles.membersName}>{user.name}</div>
                      <div className={styles.membersDesignation}>
                        {user.designation}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
        <div className={styles.btns}>
          <button className={styles.proceedBtn} onClick={doneButton}>
            Done
          </button>
        </div>
      </div>
    </div>
  );
}
